module.exports = __webpack_public_path__ + "img/vertical_4_5_8011.baf2ea5c.png";